export default "__VITE_ASSET__BYw9Cum0__"